import type { CollectionModelFieldYesNo } from '@ikegps/core-shared';
import { InputState } from '../../../components/input/input.state';
import { SwitchInput } from '../../../components/input/switch.input';
import { T, Translate } from '../../../i18n';
import type { MithrilVNode } from '../../../mithril';
import type { CollectionEditCtrl } from '../collection.view.ctrl';
import type { CollectionFieldView } from './field.view';

export const YesNoFieldView: CollectionFieldView<CollectionModelFieldYesNo> = {
	viewInline(field: CollectionModelFieldYesNo): string {
		return Translate(field.value ? T.YES : T.NO);
	},

	viewDetail(field: CollectionModelFieldYesNo): MithrilVNode {
		return null;
	},

	viewEdit(field: CollectionModelFieldYesNo, ctrl: CollectionEditCtrl): MithrilVNode {
		let inputState = ctrl.changeState.getState<boolean>(field.id);
		if (inputState == null) {
			inputState = new InputState<boolean>(field.schema.displayName);
			inputState.onValue(() => field.Mutator.manual(inputState.value));
			inputState.setValue(field.value);
			ctrl.changeState.addState(field.id, inputState);
		}

		return SwitchInput.view(inputState);
	},

	hasClear(field: CollectionModelFieldYesNo) {
		return false;
	},
};
